const STORAGE_KEY = "a11y-announcements";
const CHANGE_EVENT = "a11y-announcements-change";
export const A11Y_ANNOUNCER_ID = "registration-a11y-announcer";

export const A11Y_ANNOUNCEMENT_MODES = {
  ALL: "all",
  IMPORTANT: "important",
  OFF: "off",
};

let announceTimeoutId = null;

const isAnnouncementMode = (value) =>
  value === A11Y_ANNOUNCEMENT_MODES.ALL ||
  value === A11Y_ANNOUNCEMENT_MODES.IMPORTANT ||
  value === A11Y_ANNOUNCEMENT_MODES.OFF;

export const getA11yAnnouncementMode = () => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (isAnnouncementMode(stored)) {
      return stored;
    }
  } catch {
    // Ignore storage errors; default to announcements off.
  }
  return A11Y_ANNOUNCEMENT_MODES.OFF;
};

export const setA11yAnnouncementMode = (mode) => {
  if (!isAnnouncementMode(mode)) {
    return getA11yAnnouncementMode();
  }

  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // Ignore storage errors; in-memory listeners still receive the change.
  }

  window.dispatchEvent(
    new CustomEvent(CHANGE_EVENT, {
      detail: mode,
    })
  );
  return mode;
};

export const subscribeA11yAnnouncementMode = (listener) => {
  const handleChange = (event) => {
    if (event.type === "storage" && event.key && event.key !== STORAGE_KEY) {
      return;
    }
    listener(getA11yAnnouncementMode());
  };

  window.addEventListener(CHANGE_EVENT, handleChange);
  window.addEventListener("storage", handleChange);
  return () => {
    window.removeEventListener(CHANGE_EVENT, handleChange);
    window.removeEventListener("storage", handleChange);
  };
};

export const isA11yAnnouncementsEnabled = () =>
  getA11yAnnouncementMode() !== A11Y_ANNOUNCEMENT_MODES.OFF;

const writeLiveRegion = (message) => {
  const announcer = document.getElementById(A11Y_ANNOUNCER_ID);
  if (!announcer) {
    return;
  }

  announcer.textContent = "";
  if (announceTimeoutId) {
    window.clearTimeout(announceTimeoutId);
  }
  announceTimeoutId = window.setTimeout(() => {
    const liveNode = document.getElementById(A11Y_ANNOUNCER_ID);
    if (liveNode) {
      liveNode.textContent = message;
    }
  }, 50);
};

export const announce = (message, level = "normal") => {
  if (!message || typeof document === "undefined") {
    return;
  }

  const mode = getA11yAnnouncementMode();
  if (mode === A11Y_ANNOUNCEMENT_MODES.OFF) {
    return;
  }
  if (mode === A11Y_ANNOUNCEMENT_MODES.IMPORTANT && level !== "important") {
    return;
  }

  writeLiveRegion(message);
};

export const toggleA11yAnnouncementMode = ({
  onMessage = "Automatic announcements on",
  offMessage = "Automatic announcements off",
} = {}) => {
  const isCurrentlyOn =
    getA11yAnnouncementMode() !== A11Y_ANNOUNCEMENT_MODES.OFF;

  if (isCurrentlyOn) {
    writeLiveRegion(offMessage);
    setA11yAnnouncementMode(A11Y_ANNOUNCEMENT_MODES.OFF);
    return A11Y_ANNOUNCEMENT_MODES.OFF;
  }

  setA11yAnnouncementMode(A11Y_ANNOUNCEMENT_MODES.ALL);
  writeLiveRegion(onMessage);
  return A11Y_ANNOUNCEMENT_MODES.ALL;
};
